import { Dialog, DialogContent } from "~/components/ui/dialog";
import scanLineImg from "~/assets/landing-page/scan-line.svg";
import blidzQrImg from "~/assets/blidz-qr.png";
import closeIcon from "~/assets/landing-page/x.svg";
import { cn } from "~/lib/utils";
import appStoreImg from "~/assets/get-it-on-app-store.svg";
import googlePlayImg from "~/assets/get-it-on-google-play.svg";
import { APPSTORE_LINK, PLAYSTORE_LINK } from "~/constants";

export default function GetApp({ open, onOpenChange }: { open: boolean; onOpenChange: (open: boolean) => void }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent id="get-app-dialog" className="bg-opacity-0 border-none p-0 shadow-none" showCloseButton={false}>
        <div className="flex h-full max-h-[398px] w-full max-w-[584px] flex-col items-end justify-center gap-[16px]">
          <button
            id="get-app-close-button"
            onClick={() => onOpenChange(false)}
            className="h-9 w-9 cursor-pointer rounded-xl bg-black/60 p-2 outline outline-offset-[-1px] outline-white/10 hover:bg-black/80"
          >
            <img src={closeIcon} alt="Close" />
          </button>
          <div className="h-full max-h-[346px] w-full max-w-[584px] rounded-[24px] bg-white">
            <div
              className={cn(
                "h-full max-h-[346px] w-full max-w-[584px] rounded-[24px]",
                "bg-radial from-[#FFFEF7] to-[#FFD000]"
              )}
            >
              <div
                className={cn(
                  "flex flex-col items-center justify-center gap-[24px] p-[24px]",
                  "bg-radial from-[#FFF7A9] via-[#FFF47E] to-[#FFF50000]"
                )}
              >
                <div className="flex flex-col items-center justify-center gap-1 self-stretch">
                  <div className="flex items-center justify-start gap-2">
                    <img src={scanLineImg} alt="Scan" className="h-8 w-8" />
                    <div className="justify-start text-2xl leading-7 font-semibold text-neutral-900">
                      Scan QR code to get in Blidz App
                    </div>
                  </div>
                  <div className="justify-start text-xs leading-none font-medium text-neutral-900">
                    Enjoy unlimited Payouts and unbeatable shop discount!
                  </div>
                </div>
                <div className="h-[140px] w-[140px] rounded-[8px] bg-white p-[12px]">
                  <img src={blidzQrImg} alt="Blidz QR Code" className="h-full w-full" />
                </div>
                <div className="flex gap-2.5">
                  <a href={APPSTORE_LINK} className="cursor-pointer hover:shadow-xl">
                    <img
                      src={appStoreImg}
                      alt="Download on App Store"
                      className="h-full max-h-[56px] w-full max-w-[160px]"
                    />
                  </a>
                  <a href={PLAYSTORE_LINK} className="cursor-pointer hover:shadow-xl">
                    <img
                      src={googlePlayImg}
                      alt="Get it on Google Play"
                      className="h-full max-h-[56px] w-full max-w-[160px]"
                    />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
